import { render, staticRenderFns } from "./dwmcbgbq_year.vue?vue&type=template&id=cfea35a2&scoped=true&"
import script from "./dwmcbgbq_year.vue?vue&type=script&lang=js&"
export * from "./dwmcbgbq_year.vue?vue&type=script&lang=js&"
import style0 from "./dwmcbgbq_year.vue?vue&type=style&index=0&id=cfea35a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfea35a2",
  null
  
)

export default component.exports